import { Component } from "react";
import { RefreshCw, ShieldAlert } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, reloading: false };
    this._clearTimer = null;
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidMount() {
    // Si l'app reste stable 5 s après un rechargement auto, on ré-arme le mécanisme
    this._clearTimer = setTimeout(() => {
      try { sessionStorage.removeItem("eb_reloaded"); } catch { /* stockage indisponible */ }
    }, 5000);
  }

  componentDidCatch() {
    // Premier crash : on recharge automatiquement une fois (résout les erreurs transitoires Safari mobile)
    try {
      if (!sessionStorage.getItem("eb_reloaded")) {
        sessionStorage.setItem("eb_reloaded", "1");
        this.setState({ reloading: true });
        window.location.reload();
        return;
      }
    } catch { /* stockage indisponible → afficher l'écran */ }
  }

  componentWillUnmount() {
    if (this._clearTimer) clearTimeout(this._clearTimer);
  }

  render() {
    if (this.state.error) {
      if (this.state.reloading) {
        return (
          <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="error-boundary-reloading">
            <RefreshCw className="h-8 w-8 text-accent animate-spin" />
          </div>
        );
      }
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="error-boundary">
          <div className="max-w-sm w-full rounded-2xl border border-border bg-card p-6 text-center space-y-4 shadow-xl">
            <ShieldAlert className="h-10 w-10 text-amber-400 mx-auto" />
            <div>
              <h1 className="text-lg font-bold">Un problème d'affichage est survenu</h1>
              <p className="text-sm text-muted-foreground mt-1">Pas d'inquiétude : vos données sont en sécurité. Rechargez la page pour repartir proprement.</p>
            </div>
            <p className="text-[11px] font-mono text-muted-foreground/70 break-all max-h-20 overflow-y-auto">{String(this.state.error?.message || this.state.error)}</p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground w-full"
              data-testid="error-reload-button"
            >
              <RefreshCw className="h-4 w-4" /> Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
